export default "__VITE_ASSET__BPPDxDv4__"